{
  "bicycle": "Fahrrad",
  "bicycle_required": "Die Wahl eines Fahrrads ist obligatorisch",
  "body_height": "Größe (in cm)",
  "body_height_integer": "Die Körperlänge muss in Zentimetern und ganzen Zahlen angegeben werden",
  "body_height_positive": "Die Körperlänge muss eine positive Zahl sein",
  "body_height_required": "Die Angabe der Körperlänge ist obligatorisch",
  "body_height_too_high": "Die Körperlänge muss weniger 300 Zentimeter betragen",
  "body_height_too_low": "Die Körpergröße sollte mindestens 100 Zentimeter betragen.",
  "body_height_tooltip": "Um die Fahrräder adäquat für Sie einstellen zu können, benötigen wir bitte noch Ihre Körpergröße.",
  "cabin": "Kabine",
  "cabin_full": "Zu viele Passagiere in der Kabine",
  "cabin_required": "Kabinenzuweisung ist obligatorisch",
  "city": "Wohnort",
  "city_required": "Sie müssen einen Wohnort angeben",
  "country": "Land",
  "country_required": "Sie müssen ein Land angeben",
  "customer_remarks": "Anmerkungen des Kunden",
  "date_day_placeholder": "DD",
  "date_month_placeholder": "MM",
  "date_of_birth": "Geburtsdatum (DD-MM-JJJJ)",
  "date_of_birth_in_past": "Geburtsdatum in der Vergangenheit",
  "date_of_birth_invalid": "Geburtsdatum_ungültig",
  "date_of_birth_required": "Sie müssen ein Geburtsdatum angeben",
  "date_of_birth_too_far_in_the_past": "Geburtsdatum zu weit in der vergangenen heit",
  "date_year_placeholder": "JJJJ",
  "diet": "Besondere Ernährungswünsche",
  "email_address": "E-Mail-Adresse",
  "email_address_optional": "E-Mail-Adresse (optional)",
  "email_address_email": "E-Mail-Adresse",
  "email_address_required": "Sie müssen eine E-Mail-Adresse angeben",
  "email_address_undeliverable": "Diese E-Mail-Adresse konnte nicht überprüft werden, bitte prüfen Sie sie",
  "first_name": "Vorname",
  "first_name_required": "Sie müssen einen Vornamen angeben",
  "gender": "Geschlecht",
  "gender_choice": "Das Geschlecht muss männlich oder weiblich sein",
  "group_name": "Name der Gruppe",
  "last_name": "Nachname",
  "last_name_required": "Sie müssen einen Nachnamen angeben",
  "phone_number": "Telefonnummer",
  "phone_number_optional": "Telefonnummer (optional)",
  "phone_number_required": "Sie müssen eine Telefonnummer angeben",
  "phone_number_invalid": "Geben Sie eine gültige Telefonnummer ein",
  "search_country": "Land suchen",
  "no_countries_found": "Keine Länder gefunden",
  "state": "Staat/Provinz",
  "state_invalid": "Staat/Provinz ist ungültig",
  "state_required": "Staat/Provinz ist erforderlich",
  "street_address": "Straße",
  "street_address_required": "Sie müssen eine Straße angeben",
  "zip_code": "Postleitzahl",
  "zip_code_required": "Sie müssen eine Postleitzahl angeben"
}
